export const Toastlft = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6666 9.16732H6.52498L11.1833 4.50898L9.99998 3.33398L3.33331 10.0007L9.99998 16.6673L11.175 15.4923L6.52498 10.834H16.6666V9.16732Z"
      fill="#007EFF"
    />
  </svg>
);
